import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { stringify } from 'qs'
import { CmsFaqArticle } from 'types/cms/collection-types'
import { BiLingualValue } from 'types/common'

/**
 * Get the faqs from the CMS
 * @param {string | BiLingualValue<string[]>} slugs
 * @param {Language} locale
 * @returns {Promise<CmsFaqArticle[]>}
 */
const getFaqArticles = async (
  slugs: string | string[] | BiLingualValue<string[]>,
  locale: Language = Language.DUTCH
): Promise<CmsFaqArticle[]> => {
  try {
    const query = stringify({
      filters: {
        categories: {
          slug: {
            $in: typeof slugs === 'string' ? [slugs] : Array.isArray(slugs) ? slugs : slugs[locale]
          }
        }
      },
      locale,
      status: 'published'
    })

    const { data } = await axios.get<CMSApiResponseBody<CmsFaqArticle[]>>(
      `${process.env.CMS_API_URL}/faq-articles?populate=categories&${query}`
    )

    return data.data
  } catch (_) {
    return []
  }
}

export default getFaqArticles
